import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[fuseDecimalLimit]'
})
export class DecimalLimitDirective {
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const regex = /^-?\d*(\.\d{0,6})?/;
    const match = value.match(regex);
    if (match && match[0] !== '') {
      input.value = match[0];
    } else {
      input.value = '';
    }
  }
}